import { supabase } from "../supabase/client";

export const loadUserProfile = async (id) => {
  const { data, error } = await supabase
  .from('usuarios')
  .select('descripcion,fotoUsuario,idUsuario,nombre')
  .eq('idUsuario',id);
  return data;
}